import type { DialogBarAction } from '../Types';

import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import * as React from 'react';

import { TooltipWrapper } from '@egr/xbox/egr-gui-elements/single-components/TooltipWrapper';

import { isNotNullOrEmpty } from '@easterngraphics/wcf/modules/utils/string';

export const DialogBarActions: React.FC<{ actions?: Array<DialogBarAction>; }> = ({ actions }) => {
    if (actions == null) {
        return null;
    }

    function getAction(value: DialogBarAction, index: number, allActions: Array<DialogBarAction>): React.ReactNode {
        if (value.hide) {
            return null;
        }

        if (value.icon != null) {
            return (
                <TooltipWrapper key={index} title={value.showTooltip ? value.label : ''} childDisabled={value.disabled}>
                    <IconButton
                        data-testid="shareDialog-closeIcon"
                        color={value.color ?? 'inherit'}
                        onClick={value.callback}
                        key={index}
                        disabled={value.disabled}
                        edge={index === (allActions.length - 1) ? 'end' : undefined}
                        ref={value.ref}
                        size="large"
                        aria-label={value.label}
                    >
                        <value.icon/>
                    </IconButton>
                </TooltipWrapper>
            );
        }

        if (isNotNullOrEmpty(value.label)) {
            return (
                <TooltipWrapper key={index} title={value.showTooltip ? value.label : ''} childDisabled={value.disabled}>
                    <Button color="primary" onClick={value.callback} disabled={value.disabled}>{value.label}</Button>
                </TooltipWrapper>
            );
        }

        return null;
    }

    return (
        <React.Fragment>
            {actions.map(getAction)}
        </React.Fragment>
    );
};

DialogBarActions.displayName = 'DialogBarActions';